import React from "react";
import { Paper } from "@material-ui/core";
import TitleBox from "../components/common/TitleBox";
import PrmForm from "../components/PrmUpdate/PrmForm";
import { useHistory } from "react-router-dom";

export default function PrmCreate(props) {
  const history = useHistory();

  const handleSavePress = () => {
    //TODO: Chiamata CREATE_PRM
    history.goBack();
  };

  return (
    <Paper square elevation={0}>
      <TitleBox title={"Modulo Creazione PRM (senza prenotazione)"} />
      <PrmForm
        isCreate={true} //Distingue fase di aggiornamento da fase di creazione
        onSavePress={() => handleSavePress()}
      />
    </Paper>
  );
}
